import React, {Component} from "react"
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ZAxis
} from "recharts"

import {PaymentCurrencyType} from "@irati/types"
import theme from "@irati/ui/src/global/theme"
import {injectIntl} from "@irati/utils/lang"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"

import {ChartWrapper} from "./styled"
import {TrendTypes} from "./enums"

interface Row {
  value: number,
  date: string
}

interface Props {
  selectedTrendRate: TrendTypes,
  currencyCode: PaymentCurrencyType,
  data: Row[]
}

class BarChart extends Component<Props> {
  tickFormatter = (item: number) => {
    const {selectedTrendRate, currencyCode} = this.props
    if (selectedTrendRate === TrendTypes.engagementRate) {
      return `${item}%`
    }
    if (selectedTrendRate === TrendTypes.savings) {
      return  formatCurrency({value: item, currencyCode, isCents: false})
    }
    return item
  }

  render() {
    const {data} = this.props

    return <ChartWrapper>
      <ResponsiveContainer height={500}>
        <ComposedChart
          width={500}
          height={400}
          data={data}
          margin={{
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }}>
          <CartesianGrid vertical={false} />
          <XAxis
            dataKey="date"
            axisLine={false}
            tickLine={false} />
          <YAxis
            tickCount={6}
            tickFormatter={this.tickFormatter}
            axisLine={false}
            tickLine={false} />
          <ZAxis dataKey="value" range={[30, 30]} />
          <Bar
            id="adminSection_trendRatesBarChart"
            dataKey="value"
            fill={theme.colors.primary2}
            barSize={40} />
        </ComposedChart>
      </ResponsiveContainer>
    </ChartWrapper>
  }
}

export default injectIntl(BarChart)
